module.exports = __webpack_public_path__ + "img/gift17.a9d95070.png";